var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{class:['roles-select', 'user-roles-select' + _vm.classList],attrs:{"options":_vm.options,"options-label":"name","options-value":"rank","name":"roles[]","search":_vm.search,"multiple":"","placeholder":'Select Roles',"disabled":_vm.isDisabled},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1815ee5b","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/generic/SelectRoles.vue
// module id = 978
// module chunks = 6